export default {
  root: {
    class: [
      // Shape
      'rounded-md text-sm',

      // Spacing
      'p-0 mb-7',

      // Color
      'bg-neutral-0 dark:bg-neutral-700',
      'border-0 border-neutral-200 dark:border-neutral-700',

      // Misc
      'overflow-x-auto'
    ]
  },
  menu: {
    class: [
      // Flex & Alignment
      'flex items-center flex-nowrap',

      // Spacing
      'm-0 p-0 list-none leading-none'
    ]
  },
  action: {
    class: [
      // Flex & Alignment
      'flex items-center',

      // Shape
      'rounded-md',

      // Color
      'text-neutral-600 dark:text-white/70',

      // States
      'focus-visible:outline-none focus-visible:outline-offset-0',
      'focus-visible:ring focus-visible:ring-primary-400/50 dark:focus-visible:ring-primary-300/50',

      // Transitions
      'transition-shadow duration-200',

      // Misc
      'text-decoration-none'
    ]
  },
  icon: {
    class: 'text-neutral-600 dark:text-white/70'
  },
  separator: {
    class: [
      // Flex & Alignment
      'flex items-center',

      // Spacing
      ' mx-2',

      // Color
      'text-neutral-600 dark:text-white/70'
    ]
  }
}
